import React from "react";

import * as ListItem from "../ListItem";
import styles from "../styles.module.css";

function WithImageOnTop(props: ListItem.Props) {
  const { description, image } = props;

  return (
    <article className={styles.listItemContainer}>
      <div className={styles.mainColumn} data-skeleton-selector>
        {image && <ListItem.Image {...props} />}
        <ListItem.Text {...props} />
        {description && <ListItem.Description {...props} />}
      </div>
    </article>
  );
}

WithImageOnTop.displayName = "WithImageOnTop.Component";

export { WithImageOnTop };
